const CrossOriginImg = (
  props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
) => <img alt="" crossOrigin="anonymous" {...props} />;

export default CrossOriginImg;
